import React from 'react';

const DynamicHTMLComponent = ({ itemHtml }) => {
    return (
        <p dangerouslySetInnerHTML={{__html: itemHtml}} />
    );
};

export default DynamicHTMLComponent;